export default __webpack_public_path__ + "static/media/pinkLine.0f199879.svg";